import { Resource } from "@/types";
import { useIntervalFn } from "@vueuse/core";
import { inject, onActivated, onMounted, onUnmounted, ref, watch } from "vue";

const documentVisibility = ref<"hidden" | "visible">("visible");
const tick = ref(0)

useIntervalFn(() => {
  tick.value = (tick.value + 1) % 2;
}, 60000);

if (typeof document != "undefined") {
  document.addEventListener("visibilitychange", () => {
    documentVisibility.value = document.hidden ? "hidden" : "visible";
  });
}

export function useAutoReload<T extends Resource>(resource: T) {
  onActivated(() => resource.reload())
  watch(tick, () => resource.reload())
  watch(documentVisibility, (vis) => {
    if (vis == "visible") {
      resource.reload()
    }
  })
  return resource;
}

export function useAutoReloadDocument<T extends Resource & { doctype: string, name: string }>() {
  const $socket: any = inject("$socket")

  let resource = null;
  const cb = () => {
    if (resource?.fetched) {
      resource.reload()
    }
  };
  const on = (resource: T) => {
    $socket.emit("doc_subscribe", resource.doctype, resource.name);
    $socket.emit("doc_open", resource.doctype, resource.name);
    $socket.on("doc_update", cb);
    return resource;
  }
  const off = () => {
    if (!resource) return;
    $socket.off("doc_subscribe", cb);
    $socket.emit("doc_close", resource.doctype, resource.name);
  }

  return { on, off };
}
